"use client";

import posthog from "posthog-js";

/**
 * Marketing-site event taxonomy (redesign §9). Every event carries the
 * visitor's persona lens so funnels can segment by audience.
 */
export type MarketingEventName =
  | "calculator_engaged"
  | "calculator_result_viewed"
  | "persona_selected"
  | "pricing_recommender_used"
  | "roadmap_item_expanded"
  | "trial_cta_clicked";

export function trackMarketingEvent(
  name: MarketingEventName,
  properties: Record<string, string | number | boolean> = {}
): void {
  posthog.capture(name, properties);
}
